import isEqual from 'lodash/isEqual';

const getOptionValue = option =>
  Object.prototype.hasOwnProperty.call(option, '_value') ? Reflect.get(option, '_value') : option.value;

const setSelected = (element, value) => {
  const values = element.multiple && Array.isArray(value) ? value : [value];
  let matchedIndex = -1;

  Array.from(element.options).forEach((option, index) => {
    const isSelected = values.some(item => isEqual(item, getOptionValue(option)));
    Reflect.set(option, 'selected', isSelected);

    if (isSelected && matchedIndex === -1) {
      matchedIndex = index;
    }
  });

  if (!element.multiple) {
    Reflect.set(element, 'selectedIndex', matchedIndex);
  }
};

const onCompositionStart = event => {
  Reflect.set(event.target, 'composing', true);
};

const onCompositionEnd = event => {
  if (!event.target.composing) {
    return;
  }

  Reflect.set(event.target, 'composing', false);
  event.target.dispatchEvent(new Event('input', { bubbles: true }));
};

const addCompositionListeners = element => {
  element.addEventListener('compositionstart', onCompositionStart);
  element.addEventListener('compositionend', onCompositionEnd);
  element.addEventListener('change', onCompositionEnd);
};

const removeCompositionListeners = element => {
  element.removeEventListener('compositionstart', onCompositionStart);
  element.removeEventListener('compositionend', onCompositionEnd);
  element.removeEventListener('change', onCompositionEnd);
};

// BootstrapVue 2 render functions attach a Vue 2 native `model` directive.
// Vue 3 compat otherwise treats it as a Vue 3 v-model without an assigner.
export default {
  mounted(element, binding) {
    if (element.tagName === 'SELECT') {
      setSelected(element, binding.value);
      return;
    }

    const isTextControl = element.tagName === 'TEXTAREA' || ['text', 'search', 'url', 'tel', 'email', 'password'].includes(element.type);
    if (isTextControl && !binding.modifiers.lazy) {
      addCompositionListeners(element);
    }
  },

  updated(element, binding) {
    if (element.tagName === 'SELECT') {
      setSelected(element, binding.value);
    }
  },

  beforeUnmount(element) {
    removeCompositionListeners(element);
  }
};
